import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const GOOGLE_EMAIL_CAPTURE_NAMESPACE = '@mc/authentication/pen-3951_v2'

export const i18nInstance = registerI18nResources({
  namespace: GOOGLE_EMAIL_CAPTURE_NAMESPACE,
  resources: {
    'en-US': enUS,
  },
})
